<template>
  <el-dialog :visible.sync="dialogShow" top="8vh" class="certificate-download" width="1080px" :append-to-body="true" :show-close="false" :modal-append-to-body="true" :close-on-click-modal="true">
    <div slot="title" class="font-lg flex align-items-center">
      <div class="bd">授权证书</div>
      <div class="ft flex align-items-center">
        <el-button type="primary" size="small" :loading="loading" @click="download">下载证书</el-button>
        <div role="button" class="iconfont icon-fork ml" @click="dialogShow = false"></div>
      </div>
    </div>
    <div ref="certification" class="certification-content">
      <el-image :src="certificate_bg" alt="授权证书" style="width: 1080px; height: 1528px;display: block;" @contextmenu.prevent>
      </el-image>
      <div class="content-bd">
        <div class="flex align-items-center">
          <div class="certify-label mr">兹授权：</div>
          <div v-for="(item, index) in stars" :key="index" class="star el-icon-star-on text-danger"></div>
        </div>
        <div class="god-name text-bold">{{ god.full_name }}</div>
        <div class="certify-label">{{ '为鱼漾应用与推广战略合作伙伴' }}</div>
        <div class="certify-tip">授权范围： {{ god.partner_auth  }}</div>
        <div class="certify-tip">授权期至： {{ god.partner_expiretime | parseTime('{y} 年 {m} 月 {d} 日') }}</div>

        <div class="tip mt-hg">当前合作状态以 aiot.frippler.com 平台查询结果为准。</div>
        <div class="tip">本授权以正本为有效文本，不得影印复制或涂改。</div>
        <div class="tip">本授权不得转让或进一步授权第三方使用。</div>
        <div class="tip">鱼漾拥有此授权的最终解释权。</div>
      </div>
      <div class="content-ft">
        <div class="ft-tip">授权单位：鱼漾智能科技（上海）有限公司</div>
        <div class="ft-tip">授权日期：{{ god.partner_authtime | parseTime('{y} 年 {m} 月 {d} 日') }}</div>

        <el-image :src="stamp" alt="授权公章" class="stamp" @contextmenu.prevent></el-image>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { certificateGetApi } from '@/api/prm/prmApi'
import html2canvas from 'html2canvas';

export default {
  name: "CertificateDownload",

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  components: {
  },

  data() {
    return {
      loading: false,
      certificate_bg: require('@/assets/vesting-instrument.jpg'),
      stamp: require('@/assets/stamp.png'),
      god: {},
      loading: false
    };
  },

  created() {
    this.fetchData()
  },

  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      }
    },

    stars() {
      return Array(this.god.level).fill(1)
    }
  },

  methods: {
    fetchData() {
      certificateGetApi({
      }).then(res => {
        if (!res.errno) {
          this.god = Object.assign({}, res.data)
        } else {
          this.$message.error(res.message);
        }
      })
    },

    download () {
      this.loading = true
			html2canvas(this.$refs.certification, {
				scale: 2,
				backgroundColor: null,
				useCORS: true,
				allowTaint: false,
			}).then(canvas => {
				let dataURL = canvas.toDataURL("image/png");
				let aLink = document.createElement("a");
				aLink.style.display = "none";
				aLink.href = dataURL;
				aLink.download = "鱼漾应用与推广战略合作伙伴授权证书.png";
				document.body.appendChild(aLink);
				aLink.click();
				document.body.removeChild(aLink);
        this.loading = false
			})
		},
  }
};
</script>

<style scoped lang="scss">
.certificate-download {
  /deep/ .el-dialog__header {
    padding: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  /deep/ .el-dialog__body {
    padding: 0px;
  }
  .icon-fork {
    &:hover {
      color: #07c160;
    }
  }
  .certification-content {
    position: relative;
    user-select: none;
    .content-bd {
      position: absolute;
      top: 550px;
      left: 180px;
      right: 180px;
      .certify-label {
        color: #333;
        font-size: 36px;
        line-height: 2;
      }
      .star {
        font-size: 56px;
      }
      .god-name {
        color: #000;
        font-size: 48px;
        line-height: 2.5;
      }
      .certify-tip {
        color: #333;
        font-size: 24px;
        line-height: 2;
      }
      .tip {
        color: #333;
        font-size: 18px;
        line-height: 2;
      }
    }
    .content-ft {
      position: absolute;
      bottom: 215px;
      right: 135px;
      .ft-tip {
        color: #333;
        font-size: 22px;
        line-height: 2;
      }
      .stamp {
        position: absolute;
        top: -80px;
        right: 80px;
        width: 250px;
        height: 250px;
      }
    }
  }
}
</style>
